import "./styles.less";

import { ORDER_UY, ORDER_ce3 } from "./order";
import React, { useContext, useEffect, useState } from "react";

import { Bathrooms } from "../../../../Components/Filters/Bathrooms/web";
import { Bedrooms } from "../../../../Components/Filters/Bedrooms/web";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";
import { Floors } from "../../../../Components/Filters/Floors/web";
import { Guests } from "../../../../Components/Filters/Guests/web";
import { Keyword } from "../../../../Components/Filters/Keyword/web";
import { OperationType } from "../../../../Components/Filters/OperationType/web";
import { Price } from "../../../../Components/Filters/Price/web_2";
import { PropStates } from "../../../../Components/Filters/PropStates/web";
import { PropertyType } from "../../../../Components/Filters/PropertyType/web";
import { PublicationDate } from "../../../../Components/Filters/PublicationDate/web";
import { Rooms } from "../../../../Components/Filters/Rooms/web";
import { SurfaceRange } from "../../../../Components/Filters/SurfaceRange/web";
import { useSearchResultsFilters } from "./SearchResultsFilters.hook";
import { useTemporalFilter } from "shared-components/Components/Filters/TemporalFilter/TemporalFilter.hook";

import dynamic from "next/dynamic"
import { KeywordLocation } from "shared-components/Components/Filters/KeywordLocation/web";
import { ArrowIcon } from "shared-components/Components/CustomIcons/ArrowIcon/web";
import { LocationTagHolder } from "shared-components/Components/Filters/KeywordLocation/locationTagHolder";
import { Amenities } from "shared-components/Components/Filters/Amenities/web";
import { useAmenities } from "shared-components/Components/Filters/Amenities/Amenities.hook";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
//@ts-ignore
const TemporalFilter = dynamic(
	(): any => import("../../../../Components/Filters/TemporalFilter/web").then(mod => mod.TemporalFilter),
	{ ssr: false }
);

const Filters = ({ map, updateUrlOnRealTime=true }) => {
	const { error, changeFiltersAndUpdateURL } = useSearchResultsFilters();
	const {changeFilters} = useFilters();
	const { country_code } = useContext(ConfigStateContext);
	const [location, setLocation] = useState([]);
	const [showMore, setShowMore] = useState(false);
	const { ammenitieActiveIsNotMain } = useAmenities({country_code});

	const {
		setShowSeasonInput,
		showSeasonInput,
	} = useTemporalFilter();

	const handleChangeSeason = (show) => {
		setShowSeasonInput(show)
	}

	const handleLocations = data => {
		setLocation(data);
	};

	const handleShowAdvanced = () => {
		setShowMore(!showMore)
	}
	const handleChangeFilters = updateUrlOnRealTime ? changeFiltersAndUpdateURL: changeFilters;
	

	if (error) return null;

	const ORDER = country_code === "ce3" ? ORDER_ce3 : ORDER_UY;

	return (
		<>
			<div className="search-page-filters">				
				<div className="filter location-filter">
					<h3 className="filter-title">Ubicación</h3>

					{/* <KeywordLocation
						searchByReference={true}
						searchByProject={false}
						handleLocations={handleLocations}
						locations={location}
						isSearchForHome={true}
						isMobile={true}
					/> */}

					<LocationTagHolder/>

					<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
				</div>

				{country_code !== "ce3" && (
					<OperationType
						inputType={"buttonGroup"}
					/>
				)}

				<TemporalFilter
					isInFilters
					filterChanged={handleChangeFilters}
					showSeasonInput={showSeasonInput}
					handleChangeSeason={handleChangeSeason}
					showTitle
				/>

				<Guests filterChanged={handleChangeFilters} />

				<PropertyType
					collapsable={false}
					inputType={"boxes"}
					filterChanged={handleChangeFilters}
					showUpTo={4}
				/>
				
				<Price />

				<Bedrooms
					collapsable={false}
					filterChanged={handleChangeFilters}
					inputType="buttonGroup"
				/>

				<Rooms
					collapsable={false}
					filterChanged={handleChangeFilters}
					inputType="buttonGroup"
				/>

				<Bathrooms
					collapsable={false}
					filterChanged={handleChangeFilters}
					inputType="buttonGroup"
				/>

				<Amenities openByDefault={ammenitieActiveIsNotMain} />

				<PropStates
					collapsable={false}
					filterChanged={handleChangeFilters}
					inputType="buttonGroup"
				/>

				{showMore && (
					<>
						<PublicationDate
							filterChanged={handleChangeFilters}
							inputType="boxes"
						/>

						{country_code !== "ce3" && (
							<Floors
								filterChanged={handleChangeFilters}
								inputType="buttonGroup"
							/>
						)}

						<Keyword filterChanged={handleChangeFilters} />

						<SurfaceRange filterChanged={handleChangeFilters} />
					</>
				)}

				<button
					className="filter advanced-filters"
					onClick={handleShowAdvanced}
				>
					Filtros avanzados
					{showMore ? <ArrowIcon type="top" /> : <ArrowIcon type="bottom" />}
				</button>

				{/* Filters temporary hidden */}

				{/* <Garage filterChanged={handleChangeFilters} /> */}
				{/* <SeaDistance collapsable filterChanged={handleChangeFilters} /> */}
				{/* {country_code !== "ce3" && (
					<Disposition collapsable filterChanged={handleChangeFilters} />
				)} */}
				{/* {country_code !== "ce3" && <SocialHousing filterChanged={handleChangeFilters} />} */}
				{/* {country_code !== "ce3" && <Condominium filterChanged={handleChangeFilters} />} */}
				{/* <VirtualTour filterChanged={handleChangeFilters} /> */}
				{/* <SeenFilter filterChanged={handleChangeFilters} /> */}
			</div>

			{ORDER.map((e, i) => (
				<React.Fragment key={`order_${e}_filter_${i}`}>
					<style jsx global>{`
						.search-page-filters .filter.${e} {
							order: ${i + 1};
						}
					`}</style>
				</React.Fragment>
			))}
		</>
	);
};

export default Filters

